/* tslint:disable:max-line-length */

enum ErrorPagesQA {
  // COLUMN NAMES
  ErrorPageSectionTitle = 'ErrorPageSectionTitle',
  ErrorPageSectionSubTitle = 'ErrorPageSectionSubTitle',
}

export default ErrorPagesQA
